import WithGASetup from '../../components/WithGASetup';
import OktaLoginCallback from './OktaLoginCallback.js';

export default WithGASetup(OktaLoginCallback);
